/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisconnectUserProvider200Response
 */
export interface DisconnectUserProvider200Response {
    /**
     * 
     * @type {object}
     * @memberof DisconnectUserProvider200Response
     */
    data: object;
    /**
     * 
     * @type {object}
     * @memberof DisconnectUserProvider200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the DisconnectUserProvider200Response interface.
 */
export function instanceOfDisconnectUserProvider200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function DisconnectUserProvider200ResponseFromJSON(json: any): DisconnectUserProvider200Response {
    return DisconnectUserProvider200ResponseFromJSONTyped(json, false);
}

export function DisconnectUserProvider200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisconnectUserProvider200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': json['data'],
        'meta': json['meta'],
    };
}

export function DisconnectUserProvider200ResponseToJSON(value?: DisconnectUserProvider200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'meta': value.meta,
    };
}

